import { ObjectiveGroupSequence, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { objectiveGroupSequenceClient } from './ObjectiveGroupSequenceClient';

const factory = createStudyEntityHookFactory<ObjectiveGroupSequence>(StudyEntityType.ObjectiveGroupSequence);

export const useObjectiveGroupSequences = factory.list(objectiveGroupSequenceClient.list);
export const useObjectiveGroupSequence = factory.get(objectiveGroupSequenceClient.get);
